//# sourceMappingURL=html_parser.mjs.map
/// <reference types="./html_parser.d.mts" />
import * as $regexp from "../../gleam_regexp/gleam/regexp.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../gleam.mjs";

const FILEPATH = "src/common/html_parser.gleam";

export class EmptyElement extends $CustomType {}
export const Element$EmptyElement = () => new EmptyElement();
export const Element$isEmptyElement = (value) => value instanceof EmptyElement;

/**
 * StartElement is an opening tag like <div> and can have Attributes and child Elements
 */
export class StartElement extends $CustomType {
  constructor(name, attributes, children) {
    super();
    this.name = name;
    this.attributes = attributes;
    this.children = children;
  }
}
export const Element$StartElement = (name, attributes, children) =>
  new StartElement(name, attributes, children);
export const Element$isStartElement = (value) => value instanceof StartElement;
export const Element$StartElement$name = (value) => value.name;
export const Element$StartElement$0 = (value) => value.name;
export const Element$StartElement$attributes = (value) => value.attributes;
export const Element$StartElement$1 = (value) => value.attributes;
export const Element$StartElement$children = (value) => value.children;
export const Element$StartElement$2 = (value) => value.children;

/**
 * EndElement just has a name and signals the end of a block
 */
export class EndElement extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}
export const Element$EndElement = (name) => new EndElement(name);
export const Element$isEndElement = (value) => value instanceof EndElement;
export const Element$EndElement$name = (value) => value.name;
export const Element$EndElement$0 = (value) => value.name;

/**
 * Content is non-HTML parts of the document in-between StartElement and
 * EndElement (the "hello" in `<div>hello</div>`)
 */
export class Content extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Element$Content = ($0) => new Content($0);
export const Element$isContent = (value) => value instanceof Content;
export const Element$Content$0 = (value) => value[0];

export class Attribute extends $CustomType {
  constructor(key, value) {
    super();
    this.key = key;
    this.value = value;
  }
}
export const Attribute$Attribute = (key, value) => new Attribute(key, value);
export const Attribute$isAttribute = (value) => value instanceof Attribute;
export const Attribute$Attribute$key = (value) => value.key;
export const Attribute$Attribute$0 = (value) => value.key;
export const Attribute$Attribute$value = (value) => value.value;
export const Attribute$Attribute$1 = (value) => value.value;

class Start extends $CustomType {}

class End extends $CustomType {}

class None extends $CustomType {}

function remove_quotes(in$) {
  let remove_first_quote = (str) => {
    if (str.charCodeAt(0) === 34) {
      let remain = str.slice(1);
      return remain;
    } else {
      return str;
    }
  };
  let _pipe = in$;
  let _pipe$1 = remove_first_quote(_pipe);
  let _pipe$2 = $string.reverse(_pipe$1);
  let _pipe$3 = remove_first_quote(_pipe$2);
  return $string.reverse(_pipe$3);
}

function do_get_attrs_inner(
  loop$in,
  loop$key,
  loop$val,
  loop$finding_value,
  loop$inside_quotes
) {
  while (true) {
    let in$ = loop$in;
    let key = loop$key;
    let val = loop$val;
    let finding_value = loop$finding_value;
    let inside_quotes = loop$inside_quotes;
    let $ = in$.charCodeAt(0);
    if (in$ === "") {
      if (val === "") {
        if (key === "") {
          return [toList([]), ""];
        } else {
          return [toList([]), key];
        }
      } else {
        return [toList([new Attribute(key, remove_quotes(val))]), ""];
      }
    } else if ($ === 62 && !inside_quotes) {
      let remain = in$.slice(1);
      if (key === "" && val === "") {
        return [toList([]), remain];
      } else {
        return [toList([new Attribute(key, remove_quotes(val))]), remain];
      }
    } else if ($ === 61 && !inside_quotes) {
      let remain = in$.slice(1);
      loop$in = remain;
      loop$key = key;
      loop$val = "";
      loop$finding_value = true;
      loop$inside_quotes = false;
    } else if ($ === 34 && finding_value) {
      let remain = in$.slice(1);
      loop$in = remain;
      loop$key = key;
      loop$val = val;
      loop$finding_value = finding_value;
      loop$inside_quotes = !inside_quotes;
    } else if ($ === 32) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else if (!inside_quotes) {
        let remain = in$.slice(1);
        let $1 = do_get_attrs_inner(remain, "", "", false, false);
        let attrs = $1[0];
        let remain_after_attr = $1[1];
        return [
          listPrepend(new Attribute(key, remove_quotes(val)), attrs),
          remain_after_attr,
        ];
      } else {
        let $1 = $string.pop_grapheme(in$);
        let head;
        let remain;
        if ($1 instanceof Ok) {
          head = $1[0][0];
          remain = $1[0][1];
        } else {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            149,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $1,
              start: 3826,
              end: 3882,
              pattern_start: 3837,
              pattern_end: 3856
            }
          )
        }
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else if ($ === 10) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else if (!inside_quotes) {
        let remain = in$.slice(1);
        let $1 = do_get_attrs_inner(remain, "", "", false, false);
        let attrs = $1[0];
        let remain_after_attr = $1[1];
        return [
          listPrepend(new Attribute(key, remove_quotes(val)), attrs),
          remain_after_attr,
        ];
      } else {
        let $1 = $string.pop_grapheme(in$);
        let head;
        let remain;
        if ($1 instanceof Ok) {
          head = $1[0][0];
          remain = $1[0][1];
        } else {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            149,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $1,
              start: 3826,
              end: 3882,
              pattern_start: 3837,
              pattern_end: 3856
            }
          )
        }
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else if ($ === 9) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else if (!inside_quotes) {
        let remain = in$.slice(1);
        let $1 = do_get_attrs_inner(remain, "", "", false, false);
        let attrs = $1[0];
        let remain_after_attr = $1[1];
        return [
          listPrepend(new Attribute(key, remove_quotes(val)), attrs),
          remain_after_attr,
        ];
      } else {
        let $1 = $string.pop_grapheme(in$);
        let head;
        let remain;
        if ($1 instanceof Ok) {
          head = $1[0][0];
          remain = $1[0][1];
        } else {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            149,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $1,
              start: 3826,
              end: 3882,
              pattern_start: 3837,
              pattern_end: 3856
            }
          )
        }
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else {
      let $1 = $string.pop_grapheme(in$);
      let head;
      let remain;
      if ($1 instanceof Ok) {
        head = $1[0][0];
        remain = $1[0][1];
      } else {
        throw makeError(
          "let_assert",
          FILEPATH,
          "common/html_parser",
          149,
          "do_get_attrs_inner",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $1,
            start: 3826,
            end: 3882,
            pattern_start: 3837,
            pattern_end: 3856
          }
        )
      }
      if (finding_value) {
        loop$in = remain;
        loop$key = key;
        loop$val = val + head;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else {
        loop$in = remain;
        loop$key = key + head;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      }
    }
  }
}

function do_get_attrs(in$, key, val, finding_value) {
  return do_get_attrs_inner(in$, key, val, finding_value, false);
}

function trim_space_to_elem_begin(loop$in) {
  while (true) {
    let in$ = loop$in;
    let $ = in$.charCodeAt(0);
    if ($ === 10) {
      let remain = in$.slice(1);
      loop$in = remain;
    } else if ($ === 9) {
      let remain = in$.slice(1);
      loop$in = remain;
    } else if ($ === 60) {
      return in$;
    } else {
      return in$;
    }
  }
}

/**
 * get the attributes for a StartElement and remaining String
 */
export function get_attrs(in$) {
  let _pipe = in$;
  let _pipe$1 = trim_space_to_elem_begin(_pipe);
  return do_get_attrs(_pipe$1, "", "", false);
}

function do_get_first_element(loop$in, loop$out, loop$currently_parsing) {
  while (true) {
    let in$ = loop$in;
    let out = loop$out;
    let currently_parsing = loop$currently_parsing;
    let $ = in$.charCodeAt(0);
    if (in$.startsWith("</")) {
      let remain = in$.slice(2);
      if (out === "") {
        loop$in = remain;
        loop$out = out;
        loop$currently_parsing = new End();
      } else {
        return [new Content(out), "</" + remain];
      }
    } else if ($ === 60) {
      let remain = in$.slice(1);
      if (out === "") {
        loop$in = remain;
        loop$out = out;
        loop$currently_parsing = new Start();
      } else {
        return [new Content(out), "<" + remain];
      }
    } else if ($ === 62) {
      let remain = in$.slice(1);
      if (currently_parsing instanceof Start) {
        return [new StartElement(out, toList([]), toList([])), remain];
      } else if (currently_parsing instanceof End) {
        return [new EndElement(out), remain];
      } else {
        return [new Content(out), remain];
      }
    } else if ($ === 32 && currently_parsing instanceof Start) {
      let remain = in$.slice(1);
      let $1 = get_attrs(remain);
      let attrs = $1[0];
      let remain_after_attr = $1[1];
      return [new StartElement(out, attrs, toList([])), remain_after_attr];
    } else if ($ === 10 && currently_parsing instanceof Start) {
      let remain = in$.slice(1);
      let $1 = get_attrs(remain);
      let attrs = $1[0];
      let remain_after_attr = $1[1];
      return [new StartElement(out, attrs, toList([])), remain_after_attr];
    } else if ($ === 9 && currently_parsing instanceof Start) {
      let remain = in$.slice(1);
      let $1 = get_attrs(remain);
      let attrs = $1[0];
      let remain_after_attr = $1[1];
      return [new StartElement(out, attrs, toList([])), remain_after_attr];
    } else if (in$ === "") {
      return [new EmptyElement(), ""];
    } else {
      let $1 = $string.pop_grapheme(in$);
      let head;
      let remain;
      if ($1 instanceof Ok) {
        head = $1[0][0];
        remain = $1[0][1];
      } else {
        throw makeError(
          "let_assert",
          FILEPATH,
          "common/html_parser",
          87,
          "do_get_first_element",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $1,
            start: 2174,
            end: 2230,
            pattern_start: 2185,
            pattern_end: 2204
          }
        )
      }
      loop$in = remain;
      loop$out = out + head;
      loop$currently_parsing = currently_parsing;
    }
  }
}

/**
 * get the first Element and remaining String
 */
export function get_first_element(in$) {
  let _pipe = in$;
  let _pipe$1 = trim_space_to_elem_begin(_pipe);
  return do_get_first_element(_pipe$1, "", new None());
}

export function as_list(in$) {
  if (in$ === "") {
    return toList([]);
  } else {
    let $ = get_first_element(in$);
    let first = $[0];
    let remain = $[1];
    return listPrepend(first, as_list(remain));
  }
}

function is_void_element(name) {
  if (name === "br") {
    return true;
  } else if (name === "img") {
    return true;
  } else if (name === "hr") {
    return true;
  } else if (name === "input") {
    return true;
  } else if (name === "meta") {
    return true;
  } else if (name === "link") {
    return true;
  } else if (name === "area") {
    return true;
  } else if (name === "base") {
    return true;
  } else if (name === "col") {
    return true;
  } else if (name === "embed") {
    return true;
  } else if (name === "source") {
    return true;
  } else if (name === "track") {
    return true;
  } else if (name === "wbr") {
    return true;
  } else {
    return false;
  }
}

function do_as_tree(loop$in, loop$current) {
  while (true) {
    let in$ = loop$in;
    let current = loop$current;
    if (current instanceof StartElement) {
      let cur_name = current.name;
      let cur_attrs = current.attributes;
      let cur_children = current.children;
      let $ = is_void_element(cur_name);
      if ($) {
        return [new StartElement(cur_name, cur_attrs, toList([])), in$];
      } else {
        if (in$ === "") {
          return [
            new StartElement(
              cur_name,
              cur_attrs,
              (() => {
                let _pipe = cur_children;
                return $list.reverse(_pipe);
              })(),
            ),
            "",
          ];
        } else {
          let $1 = get_first_element(in$);
          let next = $1[0];
          let remain = $1[1];
          if (next instanceof EmptyElement) {
            if (remain === "") {
              return [
                new StartElement(
                  cur_name,
                  cur_attrs,
                  (() => {
                    let _pipe = cur_children;
                    return $list.reverse(_pipe);
                  })(),
                ),
                "",
              ];
            } else {
              loop$in = remain;
              loop$current = new StartElement(
                cur_name,
                cur_attrs,
                listPrepend(next, cur_children),
              );
            }
          } else if (next instanceof EndElement) {
            let name = next.name;
            if (name === cur_name) {
              return [
                new StartElement(
                  cur_name,
                  cur_attrs,
                  (() => {
                    let _pipe = cur_children;
                    return $list.reverse(_pipe);
                  })(),
                ),
                remain,
              ];
            } else {
              loop$in = remain;
              loop$current = current;
            }
          } else {
            let $2 = do_as_tree(remain, next);
            let child_tree = $2[0];
            let remain_after_child = $2[1];
            loop$in = remain_after_child;
            loop$current = new StartElement(
              cur_name,
              cur_attrs,
              listPrepend(child_tree, cur_children),
            );
          }
        }
      }
    } else if (current instanceof Content) {
      return [current, in$];
    } else {
      return [current, in$];
    }
  }
}

export function as_tree(in$) {
  let $ = get_first_element(in$);
  let first = $[0];
  let remain = $[1];
  let $1 = do_as_tree(remain, first);
  let result = $1[0];
  return result;
}

function newline(indent) {
  let $ = indent === 0;
  if ($) {
    return "";
  } else {
    return "\n";
  }
}

function surround(str, delimiter) {
  return (delimiter + str) + delimiter;
}

function attribute_to_html(attribute) {
  let key = attribute.key;
  let value = surround(attribute.value, "\"");
  return (key + "=") + value;
}

function attributes_to_html(attributes) {
  let attributes$1 = $list.map(attributes, attribute_to_html);
  let attributes$2 = $string.join(attributes$1, " ");
  return $bool.guard(
    $string.is_empty(attributes$2),
    attributes$2,
    () => { return " " + attributes$2; },
  );
}

function indentation(indent, current_level) {
  return $string.repeat(" ", indent * current_level);
}

function to_inner_html(children, indent, current_level) {
  let newline$1 = newline(indent);
  let _pipe = children;
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => { return do_render_html(_capture, indent, current_level + 1); },
  );
  return $string.join(_pipe$1, newline$1);
}

function do_render_html(el, indent, current_level) {
  if (el instanceof EmptyElement) {
    return "";
  } else if (el instanceof StartElement) {
    let $ = el.children;
    if ($ instanceof $Empty) {
      let name = el.name;
      let attributes = el.attributes;
      let indent_ = indentation(indent, current_level);
      let attributes$1 = attributes_to_html(attributes);
      let open = (((indent_ + "<") + name) + attributes$1) + ">";
      let close = ("</" + name) + ">";
      return $string.join(toList([open, close]), "");
    } else {
      let $1 = $.tail;
      if ($1 instanceof $Empty) {
        let $2 = $.head;
        if ($2 instanceof Content) {
          let name = el.name;
          let attributes = el.attributes;
          let txt = $2[0];
          let indent_ = indentation(indent, current_level);
          let attributes$1 = attributes_to_html(attributes);
          let open = (((indent_ + "<") + name) + attributes$1) + ">";
          let close = ("</" + name) + ">";
          return $string.join(toList([open, txt, close]), "");
        } else {
          let name = el.name;
          let attributes = el.attributes;
          let children = $;
          let indent_ = indentation(indent, current_level);
          let newline$1 = newline(indent);
          let attributes$1 = attributes_to_html(attributes);
          let inner_html = to_inner_html(children, indent, current_level);
          let open = ((((indent_ + "<") + name) + attributes$1) + ">") + newline$1;
          let close = (((newline$1 + indent_) + "</") + name) + ">";
          return $string.join(toList([open, inner_html, close]), "");
        }
      } else {
        let name = el.name;
        let attributes = el.attributes;
        let children = $;
        let indent_ = indentation(indent, current_level);
        let newline$1 = newline(indent);
        let attributes$1 = attributes_to_html(attributes);
        let inner_html = to_inner_html(children, indent, current_level);
        let open = ((((indent_ + "<") + name) + attributes$1) + ">") + newline$1;
        let close = (((newline$1 + indent_) + "</") + name) + ">";
        return $string.join(toList([open, inner_html, close]), "");
      }
    }
  } else if (el instanceof EndElement) {
    return "";
  } else {
    let txt = el[0];
    return txt;
  }
}

export function render_html(el, indent) {
  return do_render_html(el, indent, 0);
}

export function extract_attribute(name, el) {
  if (el instanceof EmptyElement) {
    return new Error(undefined);
  } else if (el instanceof StartElement) {
    let _pipe = $list.filter(el.attributes, (a) => { return a.key === name; });
    let _pipe$1 = $list.first(_pipe);
    return $result.map(_pipe$1, (a) => { return a.value; });
  } else if (el instanceof EndElement) {
    return new Error(undefined);
  } else {
    return new Error(undefined);
  }
}

/**
 * Turn a single numeric reference matched by `decode_numeric_entities` into
 * its character. The `x` submatch selects the base — hexadecimal digits are
 * only valid behind it, so `&#A0;` fails to parse and is left as-is.
 * 
 * @ignore
 */
function resolve_numeric_entity(match) {
  let $ = match.submatches;
  if ($ instanceof $Empty) {
    return match.content;
  } else {
    let $1 = $.tail;
    if ($1 instanceof $Empty) {
      return match.content;
    } else {
      let $2 = $1.head;
      if ($2 instanceof Some) {
        let $3 = $1.tail;
        if ($3 instanceof $Empty) {
          let prefix = $.head;
          let digits = $2[0];
          let _block;
          if (prefix instanceof Some) {
            let $4 = prefix[0];
            if ($4 === "x") {
              _block = $int.base_parse(digits, 16);
            } else if ($4 === "X") {
              _block = $int.base_parse(digits, 16);
            } else {
              _block = $int.parse(digits);
            }
          } else {
            _block = $int.parse(digits);
          }
          let codepoint = _block;
          let _pipe = codepoint;
          let _pipe$1 = $result.try$(_pipe, $string.utf_codepoint);
          let _pipe$2 = $result.map(
            _pipe$1,
            (codepoint) => {
              return $string.from_utf_codepoints(toList([codepoint]));
            },
          );
          return $result.unwrap(_pipe$2, match.content);
        } else {
          return match.content;
        }
      } else {
        return match.content;
      }
    }
  }
}

/**
 * Decode numeric character references into the character they designate.
 *
 * A reference that does not resolve to a valid codepoint is left untouched.
 * 
 * @ignore
 */
function decode_numeric_entities(in$) {
  let $ = $regexp.from_string("&#([xX]?)([0-9a-fA-F]+);");
  if ($ instanceof Ok) {
    let pattern = $[0];
    return $regexp.match_map(pattern, in$, resolve_numeric_entity);
  } else {
    return in$;
  }
}

/**
 * Decode the HTML entities a rich-text editor emits, so a plain-text
 * rendering shows the actual character instead of the raw `&nbsp;` escape.
 */
export function decode_entities(in$) {
  let _pipe = in$;
  let _pipe$1 = decode_numeric_entities(_pipe);
  let _pipe$2 = $string.replace(_pipe$1, "&nbsp;", "\u{00A0}");
  let _pipe$3 = $string.replace(_pipe$2, "&lt;", "<");
  let _pipe$4 = $string.replace(_pipe$3, "&gt;", ">");
  let _pipe$5 = $string.replace(_pipe$4, "&quot;", "\"");
  let _pipe$6 = $string.replace(_pipe$5, "&#39;", "'");
  let _pipe$7 = $string.replace(_pipe$6, "&apos;", "'");
  return $string.replace(_pipe$7, "&amp;", "&");
}

export function clean_html_string(html_string) {
  let html_as_list = as_list(html_string);
  let $ = get_first_element(html_string);
  let first_element = $[0];
  if (first_element instanceof EmptyElement) {
    return decode_entities(html_string);
  } else {
    let _pipe = $list.map(
      html_as_list,
      (e) => {
        if (e instanceof Content) {
          let a = e[0];
          return decode_entities(a);
        } else {
          return "";
        }
      },
    );
    return $string.join(_pipe, " ");
  }
}
